import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components/icons';
import { BRAND, BRAND_LIGHT, getThemeColors } from '../../../lib/theme';

interface DashboardToolbarProps {
  dark: boolean;
  settingsOpen: boolean;
  onToggleSettings: () => void;
}

/**
 * "Dashboard anpassen": öffnet das Einstellungs-Panel (Karten, Bereichs-Standard).
 * Das Ausblenden aus 2d9863b war ein Platzhalter ("Konfiguration noch nicht fertig"),
 * keine Ticket-Entscheidung; seit Paket 2310 ist die Konfiguration fertig.
 */
export function DashboardToolbar({ dark, settingsOpen, onToggleSettings }: DashboardToolbarProps) {
  const t = getThemeColors(dark);
  const { t: tr } = useTranslation();
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, paddingBottom: 12 }}>
      <button
        type="button"
        onClick={onToggleSettings}
        aria-pressed={settingsOpen}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '7px 13px', borderRadius: 9,
          border: `1px solid ${settingsOpen ? BRAND : t.border}`,
          background: settingsOpen ? BRAND_LIGHT : t.card,
          color: settingsOpen ? BRAND : t.text,
          fontSize: 12, fontWeight: 500, cursor: 'pointer',
          fontFamily: 'Outfit, sans-serif',
        }}
      >
        <Icon.Settings c={settingsOpen ? BRAND : t.muted} />
        {tr('dashboard.toolbar.customize')}
      </button>
    </div>
  );
}
